import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getR1InvoiceInfoPartnerTypes } from 'modules/accommodations/features/reservations/api';

export const useQueryPartnerTypes = ({ enabled = true }: { enabled?: boolean }) => {
  return useQuery(
    QUERY_KEYS.RESERVATION_R1_INVOICE_INFO_PARTNER_TYPES,
    () => getR1InvoiceInfoPartnerTypes(),
    { enabled },
  );
};
